
  import { Vue, Component, Prop } from 'vue-property-decorator';
  import { Field, DropdownField } from '@samc/centricity-core';
  import { CustodianSource } from '@/Sources';
  import { ISeller } from '@/Interfaces';

  @Component({
    name: 'custodian-dropdown-field',
    components: { Field, DropdownField }
  })
  export default class CustodianDropdownField extends Vue {
    @Prop() public value!: unknown;
    @Prop({ default: 'Custodian' }) public label!: string;
    @Prop({ type: Boolean, default: false }) public disabled!: boolean;
    @Prop({ type: Boolean, default: false }) public autoAssign!: boolean;
    @Prop({ type: Boolean, default: false }) public clearable!: boolean;
    @Prop({ type: Boolean, default: false }) public includeUnknown!: boolean;
    @Prop() public placeholder!: string;
    @Prop({ default: '' }) public errorText!: string;
    @Prop({ default: 'id' }) public valueField!: string;

    public source: CustodianSource | ISeller[] = [];

    public mounted() {
      this.source = new CustodianSource(true, this.includeUnknown);
    }

    public get val(): unknown { return this.value; }
    public set val(value: unknown) {
      this.$emit('input', value);
    }
  }
